import {
    INVOICE_BATCH_NOTIFICATION_TYPES,
    NotificationType,
    PRICE_REQUEST_NOTIFICATION_TYPES,
} from 'models/notification';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';

// DD-3726: subjectId is the customer; its invoice settings show the e-invoicing status.
const E_INVOICE_CUSTOMER_TYPES = [
    NotificationType.E_INVOICE_CUSTOMER_ACCEPTED,
    NotificationType.E_INVOICE_CUSTOMER_DECLINED,
    NotificationType.E_INVOICE_CUSTOMER_NOT_READY,
];

const CLINIC_REQUEST_TYPES = [
    NotificationType.CLINIC_REQUEST_RECEIVED,
    NotificationType.CLINIC_REQUEST_APPROVED,
    NotificationType.CLINIC_REQUEST_DECLINED,
];

/**
 * Resolves the page a notification should link to, based on its type and subject.
 * Returns undefined when the notification has no subject to navigate to.
 */

export const getNotificationSubjectUrl = (type: NotificationType, subjectId?: string): string | undefined => {
    if (!subjectId) {
        return undefined;
    }
    if (INVOICE_BATCH_NOTIFICATION_TYPES.includes(type)) {
        return `/invoices/invoice-batches/${subjectId}`;
    }
    // DD-3662: the request lists — the lab asked answers, the requester follows up.
    if (type === NotificationType.SUPPLIER_REQUEST_RECEIVED) return '/client-directory/supplier-requests';
    if (type === NotificationType.SUPPLIER_REQUEST_APPROVED) return '/suppliers/supplier-list';
    if (type === NotificationType.SUPPLIER_REQUEST_DECLINED) return '/suppliers/supplier-requests';
    // DD-3702: each side's Requests tab — the lab's in the Client directory, the clinic's
    // on the Labs page.
    if (CLINIC_REQUEST_TYPES.includes(type)) {
        return permissions.isLabTechnician(currentUserVar()?.type ?? '')
            ? '/client-directory/supplier-requests'
            : '/simple-connected-labs?tab=requests';
    }
    // DD-3697: every price-request notification opens the request (thread included).
    if (PRICE_REQUEST_NOTIFICATION_TYPES.includes(type)) return `/price-requests/${subjectId}`;
    if (E_INVOICE_CUSTOMER_TYPES.includes(type)) {
        return `/client-directory/clients/${subjectId}/invoices`;
    }
    if (type === NotificationType.NEW_COMPLETED_DRAFT_ORDER) {
        return `/orders/create-action/draft/${subjectId}`;
    }
    if (type === NotificationType.NEW_INTERNAL_CHAT_MESSAGE) {
        return `/order-details/${subjectId}/lab-internal`;
    }
    return `/order-details/${subjectId}/main-view`;
};
